var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4 text-center"},[_c('i',{staticClass:"mdi icon",class:("mdi-" + _vm.mdi_icon)}),_c('div',{staticClass:"px-2 message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }